var paragraph_default = {
  "fontElementMap": "UhYfu",
  "elementSpacing": "FvsWF",
  "text": "wH46u FvsWF",
  "child": "WhDDP"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
